import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FiMapPin, FiCalendar, FiMail, FiUsers, FiDollarSign, FiClock } from 'react-icons/fi';
import API from '../utils/api';
import './AdminPages.css';

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/api/admin/stats')
      .then(r => setData(r.data.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const statCards = data ? [
    { label: 'Active Trips',      value: data.stats.trips,          icon: <FiMapPin />,      color: 'green' },
    { label: 'Total Bookings',    value: data.stats.bookings,        icon: <FiCalendar />,    color: 'blue' },
    { label: 'Pending Bookings',  value: data.stats.pendingBookings, icon: <FiClock />,       color: 'gold' },
    { label: 'New Messages',      value: data.stats.contacts,        icon: <FiMail />,        color: 'purple' },
    { label: 'Registered Users',  value: data.stats.users,           icon: <FiUsers />,       color: 'teal' },
    { label: 'Revenue Collected', value: `₹${(data.stats.revenue || 0).toLocaleString()}`, icon: <FiDollarSign />, color: 'red' },
  ] : [];

  if (loading) return <div className="spinner" style={{ margin: '80px auto' }} />;

  return (
    <div>
      <div className="admin-page-header">
        <div>
          <h2>Dashboard</h2>
          <p>Welcome back, Admin! Here's what's happening today.</p>
        </div>
      </div>

      {/* Stats */}
      <div className="admin-stats-grid">
        {statCards.map((c, i) => (
          <motion.div
            key={c.label}
            className="admin-stat-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.07 }}
          >
            <div className={`stat-card-icon ${c.color}`}>{c.icon}</div>
            <div>
              <div className="stat-card-value">{c.value}</div>
              <div className="stat-card-label">{c.label}</div>
            </div>
          </motion.div>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
        {/* Recent Bookings */}
        <div className="admin-card">
          <div className="admin-card-header"><h3>Recent Bookings</h3></div>
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead><tr><th>Name</th><th>Trip</th><th>Status</th><th>Amount</th></tr></thead>
              <tbody>
                {data?.recentBookings?.length > 0 ? data.recentBookings.map(b => (
                  <tr key={b._id}>
                    <td>{b.name || b.user?.name || '—'}</td>
                    <td style={{ maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{b.trip?.title || '—'}</td>
                    <td><span className={`badge-status ${b.status}`}>{b.status}</span></td>
                    <td>₹{b.totalAmount?.toLocaleString()}</td>
                  </tr>
                )) : <tr><td colSpan={4} className="admin-empty">No bookings yet</td></tr>}
              </tbody>
            </table>
          </div>
        </div>

        {/* Recent Messages */}
        <div className="admin-card">
          <div className="admin-card-header"><h3>Recent Messages</h3></div>
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead><tr><th>Name</th><th>Subject</th><th>Status</th></tr></thead>
              <tbody>
                {data?.recentContacts?.length > 0 ? data.recentContacts.map(c => (
                  <tr key={c._id}>
                    <td>{c.name}</td>
                    <td style={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.subject}</td>
                    <td><span className={`badge-status ${c.status}`}>{c.status}</span></td>
                  </tr>
                )) : <tr><td colSpan={3} className="admin-empty">No messages yet</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
